// @flow
import React from 'react';
import ProfileActivities from 'app/common/react/components/profile/ProfileActivities/ProfileActivities';
import withResource from 'app/common/lib/react/withResource';
import withRouteData from 'app/common/lib/react/withRouteData';
import { compose } from 'redux';
import withViewer, { type Viewer } from 'app/common/lib/react/withViewer';

type Props = {
  data: Object,
  params: { username: string },
  user: Object,
  viewer: Viewer,
};

function ProfileActivitiesContainer(props: Props) {
  const { user, params, viewer } = props;
  if (!user || !user.data) {
    return null;
  }

  const isOwnProfile = viewer.isAuth && viewer.username === params.username;

  return <ProfileActivities isOwnProfile={isOwnProfile} user={user.data} />;
}

export default compose(
  withViewer,
  withResource({
    name: 'UserResource',
    key: 'user',
    options: ({ params }) => ({
      username: params.username,
      field_set_key: 'profile',
    }),
  }),
  withRouteData({
    name: 'ProfileActivities',
    routeContextLog: (context: Object, params: { username: string }) => {
      let userId;
      if ((context.user || {}).username === params.username) {
        userId = context.user.id;
      }
      return {
        object_id_str: userId,
        view_type: PCONST.thrift.ViewType.USER,
        view_parameter: PCONST.thrift.ViewParameterType.USER_ACTIVITY,
      };
    },
  }),
)(ProfileActivitiesContainer);
